import React from 'react';

export default function MediaSection() {
  return (
    <section className="media-section" id="media">
      <div className="media-container">
        <h2 className="section-title">Media</h2>
        <p className="media-subtitle">Watch our latest showcase video</p>
        <div className="media-wrapper">
          <video className="media-video" controls autoPlay muted loop>
            <source src="assets/media.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </section>
  );
}
